import {
  MAIN_SITE_ENVIRONMENT_HOST,
  PRACTICAL_STREAM_CDN_ADDRESS,
  USE_CDN,
} from '../utilities/config'
import { HOST } from '../../pages/api/utils/config'

export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_TITLE: string =
  'How the Right Playlist Can Increase Restaurant Sales by 15% — Backed by Psychology'
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_TITLE_ES: string =
  'Cómo la lista de reproducción adecuada puede aumentar las ventas de un restaurante en un 15%, con el respaldo de la psicología'
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_TITLE_FR: string =
  'Comment la bonne liste de lecture peut augmenter les ventes des restaurants de 15 % – soutenue par la psychologie'
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_TITLE_KO: string =
  '올바른 재생 목록이 레스토랑 매출을 15% 증가시킬 수 있는 방법 — 심리학 지원'

export const HOW_THE_RIGHT_PLAYLIST_TITLE_HTML: JSX.Element = (
  <>
    How the Right Playlist Can Increase Restaurant Sales by 15% — Backed by
    Psychology
  </>
)
export const HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_ES: JSX.Element = (
  <>
    Cómo la lista de reproducción adecuada puede aumentar las ventas de un
    restaurante en un 15%, con el respaldo de la psicología
  </>
)
export const HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_FR: JSX.Element = (
  <>
    Comment la bonne liste de lecture peut augmenter les ventes des restaurants
    de 15&nbsp;% – soutenue par la psychologie
  </>
)
export const HOW_THE_RIGHT_PLAYLIST_TITLE_HTML_KO: JSX.Element = (
  <>
    <span aria-hidden={true} className={'atb'}>
      올바른
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      재생
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      목록이
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      레스토랑
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      매출을
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      15%
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      증가시킬
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      수
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      있는
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      방법
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      —
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      심리학
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      지원
    </span>
  </>
)

export const HOW_THE_RIGHT_PLAYLIST_PAGE_ID: string =
  '090AB011-6405-40A3-97B4-25A2B3CC17F1'

export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE: string =
  '/articles/how-the-right-playlist-can-increase-restaurant-sales'
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_ES: string =
  '/articles/how-the-right-playlist-can-increase-restaurant-sales'
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_FR: string =
  '/articles/how-the-right-playlist-can-increase-restaurant-sales'
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_KO: string =
  '/articles/how-the-right-playlist-can-increase-restaurant-sales'

export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_URL: string =
  HOST + HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_ES
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_URL_ES: string =
  HOST + '/es' + HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_ES
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_URL_FR: string =
  HOST + '/fr' + HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_FR
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_URL_KO: string =
  HOST + '/ko' + HOW_THE_RIGHT_PLAYLIST_ARTICLE_ROUTE_KO

export const ARTICLE_KEYWORDS =
  'business music, music for restaurants, music for cafes, increase revenue for restaurants, increase sales for restaurants, background music streaming, business background music, ambient music, licensed music, practical stream'
export const ARTICLE_KEYWORDS_ES =
  'música para negocios, música para restaurantes, música para cafeterías, aumentar los ingresos para restaurantes, aumentar las ventas para restaurantes, transmisión de música de fondo, música de fondo para negocios, música ambiental, música con licencia, practical stream'
export const ARTICLE_KEYWORDS_FR =
  'musique pour les entreprises, musique pour les restaurants, musique pour les cafés, augmenter les revenus des restaurants, augmenter les ventes des restaurants, musique de fond en streaming, musique de fond pour les entreprises, musique de fond, musique sous licence, practical stream'
export const ARTICLE_KEYWORDS_KO =
  '비즈니스용 음악, 레스토랑용 음악, 카페용 음악, 레스토랑 수익 증대, 레스토랑 매출 증대, 스트리밍 배경 음악, 비즈니스 배경 음악, 배경 음악, 라이센스 음악, 편리한 스트리밍, practical stream'

export const ARTICLE_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '98EAA254-D7D3-42EC-96B3-BA67FADD6B6E.avif'
  : HOST + '/images/98EAA254-D7D3-42EC-96B3-BA67FADD6B6E.avif'
export const ARTICLE_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '98EAA254-D7D3-42EC-96B3-BA67FADD6B6E.jpg'
  : HOST + '/images/98EAA254-D7D3-42EC-96B3-BA67FADD6B6E.jpg'
export const OPEN_GRAPH_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '518700E0-3CA6-49D2-A97C-82611C047BA4.jpg'
  : HOST + '/images/518700E0-3CA6-49D2-A97C-82611C047BA4.jpg'

export const HOW_THE_RIGHT_JSON_LD_IMAGE_1200_X_1200: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '98EAA254-D7D3-42EC-96B3-BA67FADD6B6E.png'
  : HOST + '/images/98EAA254-D7D3-42EC-96B3-BA67FADD6B6E.png'

export const ARTICLE_SUMMARY: string =
  'Restaurant background music isn’t just an ambient noise — it’s a psychological tool that can have a dramatic impact on how much your clientele spends, how long they linger, and whether they’ll return. Here we explore how to improve your restaurant background music strategy.'
export const ARTICLE_SUMMARY_ES: string =
  'La música de fondo de un restaurante es más que sólo ruido ambiental. Es una herramienta psicológica que puede tener un impacto dramático en cuánto gastan sus clientes, cuánto tiempo permanecen y si regresan. Aquí veremos cómo mejorar la estrategia de música de fondo de su restaurante.'
export const ARTICLE_SUMMARY_FR: string =
  "La musique d’ambiance dans un restaurant est bien plus qu’un simple bruit ambiant. Il s'agit d'un outil psychologique qui peut avoir un impact considérable sur le montant dépensé par vos clients, la durée de leur séjour et leur retour. Nous verrons ici comment améliorer la stratégie de musique de fond de votre restaurant."
export const ARTICLE_SUMMARY_KO: string =
  '레스토랑 배경 음악은 단순한 주변 소음이 아닙니다. 고객이 지출하는 금액, 머무르는 시간, 재방문 여부에 극적인 영향을 미칠 수 있는 심리적 도구입니다. 여기서는 레스토랑 배경 음악 전략을 개선하는 방법을 살펴보겠습니다.'

export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_PUBLISHED_STR: string = '2025-11-12'
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_CREATED_STR: string = '2025-11-12'
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_PUBLISHED: Date = new Date(
  HOW_THE_RIGHT_PLAYLIST_ARTICLE_PUBLISHED_STR
)
export const HOW_THE_RIGHT_PLAYLIST_ARTICLE_CREATED: Date = new Date(
  HOW_THE_RIGHT_PLAYLIST_ARTICLE_CREATED_STR
)

export const PRACTICAL_STREAM_RESTAURANT_HERO_PAGE_URL: string =
  MAIN_SITE_ENVIRONMENT_HOST + '/restaurants'
export const PRACTICAL_STREAM_RESTAURANT_HERO_PAGE_URL_ES: string =
  MAIN_SITE_ENVIRONMENT_HOST + '/es' + '/restaurantes'
export const PRACTICAL_STREAM_RESTAURANT_HERO_PAGE_URL_FR: string =
  MAIN_SITE_ENVIRONMENT_HOST + '/fr' + '/restaurants'
export const PRACTICAL_STREAM_RESTAURANT_HERO_PAGE_URL_KO: string =
  MAIN_SITE_ENVIRONMENT_HOST + '/ko' + '/레스토랑'

export const PRACTICAL_STREAM_PLAYLIST_PAGE_URL: string =
  MAIN_SITE_ENVIRONMENT_HOST + '/playlist'
export const PRACTICAL_STREAM_PLAYLIST_PAGE_URL_ES: string =
  MAIN_SITE_ENVIRONMENT_HOST + '/es' + '/playlist'
export const PRACTICAL_STREAM_PLAYLIST_PAGE_URL_FR: string =
  MAIN_SITE_ENVIRONMENT_HOST + '/fr' + '/playlist'
export const PRACTICAL_STREAM_PLAYLIST_PAGE_URL_KO: string =
  MAIN_SITE_ENVIRONMENT_HOST + '/ko' + '/재생목록'
